import React from "react";
import { Link } from "components";
import { WpCategory } from "codegen";
import "./FilterTags.scss";

interface FilterTagsProps {
  categories?: WpCategory[] & any; // Account for Intrinsic Types
  placeholderText?: string;
  categoryPage?: boolean;
}

/**
 * Filter component that will navigate to the category pages
 *
 * @param tagItems - Items to be displays within the tags, would be a post category
 * @param placeholderText - The text to be displays next to tags
 * @returns Display categories through posts or pages that are passed down
 *
 */
export const FilterTags = ({
  categories = [],
  placeholderText = "Filter:",
  categoryPage,
}: FilterTagsProps): JSX.Element => {
  if (categories.length === 0) return null;

  // this will need to change if the URL is different
  const pathPostType = categories[0].uri.split("/")[1];

  return (
    <div className="filter--tags">
      <span className="filter--tags__heading">{placeholderText}</span>

      {/* Maps through all categories and returns the ones which aren't "uncategorised" */}
      {Object.keys(categories).length > 0 &&
        categories.flatMap((item, index) => {
          return item.slug !== "uncategorised" ? (
            <Link to={`${item.uri}`} className="filter--tags__tag" key={`${item.id}-${index}`}>
              {item.name}
            </Link>
          ) : null;
        })}
      {categoryPage && (
        <Link to={`/${pathPostType}/`} className="filter--tags__clear">
          Clear Filters X
        </Link>
      )}
    </div>
  );
};
